import { Chip, Tooltip } from '@mui/material';
import { State } from '@thro-types/billing';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export enum AdditionalInvoiceState {
  INCOMPLETE = 'INCOMPLETE',
  CANCELLED = 'CANCELLED'
}

export type InvoiceStateWithAdditional = keyof typeof State | AdditionalInvoiceState;

export const InvoiceStateChip = ({
  state,
  cancelled
}: {
  state: InvoiceStateWithAdditional;
  cancelled: boolean | undefined;
}) => {
  const { t } = useTranslation();

  const handleCancelled = (state: InvoiceStateWithAdditional) => {
    if (cancelled) {
      return AdditionalInvoiceState.CANCELLED;
    }
    return state;
  };

  const getColor = (state: InvoiceStateWithAdditional) => {
    state = handleCancelled(state);
    switch (state) {
      case State.DRAFT:
        return '#888';
      case State.READY:
        return '#37f';
      case State.APPROVED:
        return '#5a5';
      case State.DENIED:
        return '#f66';
      case State.FINAL:
        return '#d5d';
      case State.ARCHIVED:
        return '#dd3';
      case AdditionalInvoiceState.CANCELLED:
        return '#f33';
      case AdditionalInvoiceState.INCOMPLETE:
        return '#38a7ce';
      default:
        return '#222';
    }
  };

  const getStateTranslation = (state: InvoiceStateWithAdditional) => {
    state = handleCancelled(state);
    switch (state) {
      case State.DRAFT:
        return t(translations.pages.billing.states.draft());
      case State.READY:
        return t(translations.pages.billing.states.open());
      case State.APPROVED:
        return t(translations.pages.billing.states.approved());
      case State.DENIED:
        return t(translations.pages.billing.states.denied());
      case State.FINAL:
        return t(translations.pages.billing.states.final());
      case State.ARCHIVED:
        return t(translations.pages.billing.states.archived());
      case AdditionalInvoiceState.CANCELLED:
        return t(translations.pages.billing.states.cancelled());
      case AdditionalInvoiceState.INCOMPLETE:
        return t(translations.pages.billing.states.incomplete());
      default:
        return 'Unknown';
    }
  };

  return (
    <Tooltip
      title={
        state === AdditionalInvoiceState.INCOMPLETE
          ? t(translations.pages.billing.validation.missingFields())
          : ''
      }
    >
      <Chip
        label={getStateTranslation(state)}
        sx={{
          backgroundColor: getColor(state),
          width: '9em',
          borderRadius: '0.5em',
          fontWeight: 500,
          color: 'white'
        }}
      />
    </Tooltip>
  );
};
